

export class LoginSettings {
    static UI = {
        labels: {
            site: 'Acuadori Thingsboard',
            user: 'Email',
            pwd: 'Password'
        },
        userType: 'email',
        siteSelection: [process.env.REACT_APP_THINGSBOARD_URL],
        defaultSelection: 0,
        userPlaceholder: 'acuadori-user@abinsula.com'
    }
}


export class IntroSettings {
    static UI = {
        title: 'Acuadori'
    }
}


class UiSettings {
    static Login = LoginSettings.UI;
    static ChirpstackLogin = {
    title: 'Acuadori LoraWAN',
    labels: {
        site: 'ChirpStack REST API',
        apiKey: 'API Key'
    },
    apiKeyMode: true,
    apiKeyPlaceholder: 'Inserisci la API key ChirpStack',
    siteSelection: [process.env.REACT_APP_CHIRPSTACK_API_URL],
    defaultSelection: 0
    }
    static Intro = IntroSettings.UI;
}

export default UiSettings;

